module.exports = __webpack_public_path__ + "img/dlw-medical-group-logo.9a6df8ad.svg";